import React, { useEffect, useState, useRef } from "react";
import WorkoutPreview from "../components/workout/WorkoutPreview";
import { db } from "../config/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { saveExercise } from "../utils/saveExercise";
import { toast } from "react-toastify";

export default function PreviewPage({ user, ...props }) {
  const [savedExerciseIds, setSavedExerciseIds] = useState([]);
  const hasProcessedBookmarkActionRef = useRef(false);

  useEffect(() => {
    const fetchSavedExerciseIds = async () => {
      if (!user) return;

      try {
        const q = query(
          collection(db, "savedExercises"),
          where("userId", "==", user.uid)
        );
        const snapshot = await getDocs(q);
        console.log("Fetched docs:", snapshot.docs.map(doc => doc.data())); // 👀 check what fields exist
        const ids = snapshot.docs.map((doc) => doc.data().exerciseId || doc.data().id);
        console.log("Extracted exerciseIds:", ids);
        setSavedExerciseIds(ids);
      } catch (error) {
        console.error("Error fetching saved exercises:", error);
      }
    };

    fetchSavedExerciseIds();
  }, [user]);

  // Handle post-login bookmark
  useEffect(() => {
    const handlePostLoginBookmark = async () => {
      if (!user || hasProcessedBookmarkActionRef.current) return;

      const pendingBookmarkAction = localStorage.getItem("pendingBookmarkAction");
      if (pendingBookmarkAction) {
        const { action, exerciseId, exerciseName } = JSON.parse(pendingBookmarkAction);
        if (action === "bookmark") {
          // Find the exercise in the current workout
          const exercise = props.exercises?.find(ex => ex.id === exerciseId);
          if (exercise) {
            try {
              const savedId = await saveExercise(user, exercise);
              if (savedId) {
                setSavedExerciseIds(prev => [...prev, exercise.id]);
                toast.success(`${exercise.name} saved to your library!`);
              } else {
                toast.info(`${exercise.name} is already saved.`);
              }
            } catch (err) {
              console.error("Error saving exercise after login:", err);
              toast.error("Something went wrong.");
            }
          }
          localStorage.removeItem("pendingBookmarkAction");
          hasProcessedBookmarkActionRef.current = true;
        }
      }
    };

    handlePostLoginBookmark();
  }, [user]);

  return (
    <WorkoutPreview
      user={user}
      savedExerciseIds={savedExerciseIds}
      setSavedExerciseIds={setSavedExerciseIds}
      {...props}
    />
  );
}
